import React from 'react';
import { connect } from 'react-redux';
import { State } from 'module/Redux';
import { RouterSelector } from 'module/Redux/Router';
import { PathUtils, createPureComponent } from 'module/Common';

type StateProps = {
  lang: PathUtils.Lang;
};

const mapStateToProps = (s: State): StateProps => ({
  lang: RouterSelector.selectLang(s),
});

type OwnProps = {
  renderFr: () => React.ReactNode;
  renderEn: () => React.ReactNode;
};

type Props = OwnProps & StateProps;

const LocalizedRendererComp = createPureComponent<Props>('LocalizedRenderer', ({ lang, renderEn, renderFr }) => {
  return <>{lang === 'fr' ? renderFr() : renderEn()}</>;
});

export const LocalizedRenderer = connect(mapStateToProps)(LocalizedRendererComp);



// WEBPACK FOOTER //
// ./src/module/View/Common/component/LocalizedContent/LocalizedRenderer.tsx